<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { AppBadge } from '@shared/ui/badges'

import { useTableAssessmentTemplates } from '../../model/assessments/table-assessment-templates.hook'
import AssessmentTemplateActions from './AssessmentTemplateActions.vue'

defineOptions({
  name: 'TableAssessmentTemplates',
})

const {
  templates,
  isLoading,
  hasTemplates,
  meta,
  perPageOptions,
  formatDateTime,
  getTypeLabel,
  getDisciplineLabel,
  getGrade,
  getStatusLabel,
  getStatusColor,
  openTemplate,
  setChangePage,
  setChangePerPage,
} = useTableAssessmentTemplates()
</script>

<template>
  <div class="table-assessment-templates">
    <AppTable
      class="rounded-table"
      :meta="meta"
      :per-page-options="perPageOptions"
      :loading="isLoading"
      @change:page="setChangePage"
      @change:per-page="setChangePerPage"
    >
      <template #head>
        <AppTr>
          <AppTh class="text-center table-assessment-templates__id-cell">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              #
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Title
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Type
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Discipline
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Grade
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Status
            </AppText>
          </AppTh>
          <AppTh class="text-center">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Screens
            </AppText>
          </AppTh>
          <AppTh class="text-center">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Activities
            </AppText>
          </AppTh>
          <AppTh class="text-center">
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Assessments
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              Updated
            </AppText>
          </AppTh>
          <AppTh class="table-assessment-templates__actions-cell" />
        </AppTr>
      </template>

      <template
        v-if="hasTemplates"
        #body
      >
        <AppTr
          v-for="template in templates"
          :key="template.id"
        >
          <AppTd class="medium text-center table-assessment-templates__id-cell">
            <button
              type="button"
              class="table-assessment-templates__cell-link"
              :aria-label="`Open ${template.title}`"
              @click="openTemplate(template)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ template.id }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <button
              type="button"
              class="table-assessment-templates__cell-link"
              :aria-label="`Open ${template.title}`"
              @click="openTemplate(template)"
            >
              <AppText
                name="body1"
                color="blue-600"
              >
                {{ template.title }}
              </AppText>
            </button>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ getTypeLabel(template) }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ getDisciplineLabel(template) }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ getGrade(template) }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppBadge
              :color="getStatusColor(template)"
              :text="getStatusLabel(template)"
            />
          </AppTd>
          <AppTd class="medium text-center">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ template.screens_count }}
            </AppText>
          </AppTd>
          <AppTd class="medium text-center">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ template.activities_count }}
            </AppText>
          </AppTd>
          <AppTd class="medium text-center">
            <AppText
              name="body1"
              :color="template.assessments_count > 0 ? 'blue-600' : 'slate-900'"
            >
              {{ template.assessments_count }}
            </AppText>
          </AppTd>
          <AppTd class="medium table-assessment-templates__date-cell">
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ formatDateTime(template.updated_at) }}
            </AppText>
          </AppTd>
          <AppTd class="zero-padding table-assessment-templates__actions-cell">
            <AssessmentTemplateActions :template="template" />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./TableAssessmentTemplates.scss" />
